
<template>
  <div>
    <NewPayment kind="envelope" envelope_type="check" @close="$router.push({ name: 'OpenEnvelopes' })"></NewPayment>
  </div>
</template>

<script>

export default {
  name: 'NewCheck',
  components: {
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
}
</script>
